export default __webpack_public_path__ + "media/images/mud-run-logo-ea202db2ab94dafd44cc48b1c63946af.jpg";